import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    SponsoredTelemed: {
        id: 'Search.Results.Primitives.SponsoredBanner.SponsoredTelemedicine',
        defaultMessage: 'Sponsored Telemedicine',
    },

    AdHook: {
        id: 'Search.Results.Primitives.Telehealth.Hook',
        defaultMessage: 'Need care faster? ',
    },

    AdBlurb: {
        id: 'Search.Results.Primitives.Telehealth.Blurb',
        defaultMessage: 'Video chat with a physician and get the care you need right away, including prescriptions or referrals.',
    },

    AdStartButtonMessage: {
        id: 'Search.Results.Primitives.Telehealth.ButtonMessage',
        defaultMessage: 'Doctor available now',
    },

    FastCareTitle: {
        id: 'Search.Results.Primitives.Telehealth.FastCareTitle',
        defaultMessage: 'Fast care anywhere',
    },

    CertifiedDoctorTitle: {
        id: 'Search.Results.Primitives.Telehealth.QualityCareTitle',
        defaultMessage: 'Be confident in your care',
    },

    FastCareMessage: {
        id: 'Search.Results.Primitives.Telehealth.FastCareMessage',
        defaultMessage: 'Start a live video in a matter of minutes from your couch, office, or literally anywhere.',
    },

    CertifiedDoctorMessage: {
        id: 'Search.Results.Primitives.Telehealth.QualityCareMessage',
        defaultMessage: 'Doctors are board-certified and can provide a consultation, prescriptions, or referrals.',
    },

    Review: {
        id: 'Search.Results.Primitives.Telehealth.Review',
        defaultMessage: 'Fantastic! Short wait time and I got the information that I needed. I will use this service again.',
    },

    ReviewAttribution: {
        id: 'Search.Results.Primitives.Telehealth.ReviewAttribution',
        defaultMessage: '- Ariel G., verified patient.',
    },

    ModalHeader: {
        id: 'Search.Results.Primitives.Telehealth.ModalHeader',
        defaultMessage: 'Video chat with a doctor',
    },

    VideoVisitAlt: {
        id: 'Search.Results.Primitives.Telehealth.VideoVisitAlt',
        defaultMessage: 'Video Visit',
    },

    CertifiedDoctorAlt: {
        id: 'Search.Results.Primitives.Telehealth.CertifiedDoctorAlt',
        defaultMessage: 'Certified Doctors',
    },

    DownloadButtonPrompt: {
        id: 'Search.Results.Primitives.Telehealth.DownloadButtonPrompt',
        defaultMessage: 'Download the Zocdoc app',
    },

    SendSmsDescription: {
        id: 'Search.Results.Primitives.Telehealth.SendSmsDescription',
        defaultMessage: 'Download the Zocdoc app to begin your video visit',
    },

    BranchDownloadDescription: {
        id: 'Search.Results.Primitives.Telehealth.BranchDownloadDescription',
        defaultMessage: 'Video visits are only available in our app',
    },

    SendSmsButtonPrompt: {
        id: 'Search.Results.Primitives.Telehealth.SendSmsButtonPrompt',
        defaultMessage: 'Text me link to app',
    },

    BranchSmsLoading: {
        id: 'Search.Results.Primitives.Telehealth.BranchSmsLoading',
        defaultMessage: 'Sending...',
    },

    BranchSmsSuccess: {
        id: 'Search.Results.Primitives.Telehealth.BranchSmsSuccess',
        defaultMessage: 'Sent!',
    },

    BranchSmsFailure: {
        id: 'Search.Results.Primitives.Telehealth.BranchSmsFailure',
        defaultMessage: 'Try again',
    },

    BranchTextTitle: {
        id: 'Search.Results.Primitives.Telehealth.BranchTextTitle',
        defaultMessage: 'Zocdoc Video Visit',
    },

    BranchTextMessage: {
        id: 'Search.Results.Primitives.Telehealth.BranchTextTitle.CLickHere',
        defaultMessage: 'Click here to download Zocdoc and book a video call with a doctor',
    },
});

export const ATTRIBUTION_TYPES = {
    click: 0,
    impression: 1,
    clickConversion: 2,
    viewConversion: 3,
    appFinalized: 4,
};

export const BRANCH_TAGS = ['telehealth', 'sponsored-result', 'search-results-page'];
